import { useEffect, useState, useRef, useCallback } from "react";
import { Container, TextField, MenuItem, Button, Grid, Typography, ButtonGroup, Dialog, DialogTitle, DialogContent, DialogActions, CardHeader, Autocomplete, IconButton, Tooltip, Chip, Checkbox, Card, CardContent, CardActions, Menu } from "@mui/material";
import { useAuth } from "../hooks/useAuth";
import { GetTokenIdentity } from "../utils/Token";
import { Countries, ServiceStatus } from "../utils/Lookup";
import { GroupHeader, GroupItems } from "../utils/Styled";
import { Icons } from "../utils/Icon";
import { CustomStyles } from "../utils/Styled";
import Swal from "sweetalert2";

import axios from "axios";
import moment from "moment";
import MaterialTable from "material-table";

import DateRangePicker from "../components/common/DateRangePicker";
import CreateServiceForm from "../components/forms/services/Create";
import EditServiceForm from "../components/forms/services/Edit";
import ViewServiceForm from "../components/forms/services/View";
import DeleteServiceForm from "../components/forms/services/Delete";
import ImportServiceForm from "../components/forms/services/Import";
import ViewContractForm from "../components/forms/contracts/View";
import RelationshipServicesForm from "../components/forms/services/Services";

import CountrySelect from "../components/common/CountrySelect";

export const ServicesPage = () => {
    const { token, logout } = useAuth();
    const identity = GetTokenIdentity(token);

    const classes = CustomStyles;

    const organizationInputRef = useRef(null);
    const serviceNoInputRef = useRef(null);

    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [filter, setFilter] = useState({
        service_no: "", org_name: "", start_date: null, end_date: null, status: 0, user_id: "", is_request_close: "", country_id: identity.user.country_id, product_id: []
    });
    const [sort, setSort] = useState({});

    const [userCountry, setUserCountry] = useState([]);

    useEffect(() => {
        async function fetchCountryData() {
            const response = await axios.get(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/users/access-country`);
            setUserCountry(response.data.data.countries);
        }
        fetchCountryData();
    }, []);

    const [open, setOpen] = useState({
        create: false,
        edit: false,
        view: false,
        import: false,
        viewContract: false,
        viewService: false
    });
    const [selectedRow, setSelectedRow] = useState({});

    const [pendingCount, setPendingCount] = useState(0);
    const [pendingCompleteCount, setpendingCompleteCount] = useState(0);

    const [usersData, setUsersData] = useState([]);
    const [productsData, setProductsData] = useState([]);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [pdfMenuAnchorEl, setPdfMenuAnchorEl] = useState(null);
    const [selectedPdfRow, setSelectedPdfRow] = useState(null);
    const [selectedService, setSelectedService] = useState(null);
    const [emailDialogOpen, setEmailDialogOpen] = useState(false);
    const [emailTemplate, setEmailTemplate] = useState({
        subject: '',
        body: '',
        cc: '',
        bcc: ''
    });

    const formatDate = (date) => moment(date).format("YYYY-MM-DD");

    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };

    const handleOpen = (type, row) => {
        if (type === "viewContract") {
            axios
            .get(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/contracts/${row.contract_id}`)
            .then((response) => {
                setSelectedRow(response.data.data);
                setOpen({ ...open, [type]: true });
            })
            .catch((error) => console.log(error));
        } else {
            setOpen({ ...open, [type]: true });
            setSelectedRow(row);
        }
    };

    const handleClose = (type) => {
        if (type === "viewService") {
            fetchData();
        }
        setOpen({ ...open, [type]: false });
        setSelectedRow(null);
    };

    const handleResetFilter = () => {
        setPage(0);
        setFilter({ service_no: "", org_name: "", start_date: null, end_date: null, status: 0, user_id: "", is_request_close: "", country_id: identity.user.country_id, product_id: [] });
        setStartDate(null);
        setEndDate(null);
    };

    const handlePendingFilter = () => {
        setPage(0);
        setFilter({ service_no: "", org_name: "", start_date: null, end_date: null, status: 0, user_id: identity.user.user_id, is_request_close: "", country_id: "", product_id: [] });
        setStartDate(null);
        setEndDate(null);
    };

    const handlePendingCompleteFilter = () => {
        setPage(0);
        setFilter({ service_no: "", org_name: "", start_date: null, end_date: null, status: 0, user_id: identity.user.user_id, is_request_close: 1, country_id: "", product_id: [] });
        setStartDate(null);
        setEndDate(null);
    };

    const handleFilterChange = (event) => {
        setPage(0);
        setFilter({ ...filter, [event.target.name]: event.target.value });
        setFilter((prevFilter) => {
            if (prevFilter.country_id !== filter.country_id) {
                return { ...prevFilter, product_id: [] };
            }
            return prevFilter;
        });
    };

    const handleProductFilterChange = (selectedValue) => {
        setPage(0);
        setFilter({ ...filter, product_id: selectedValue });
    };

    const handleUserFilterChange = (selectedValue) => {
        setPage(0);
        setFilter({ ...filter, user_id: selectedValue ? selectedValue.user_id : "" });
    };

    const downloadExcelFile = () => {
        const now = moment().format("YYYY-MM-DD_HH-mm-ss");
        const fileName = `Service_${now}.xlsx`;

        let customFilter = { ...filter };
        customFilter.start_date = moment(customFilter.start_date).isValid() ? moment(customFilter.start_date).format("YYYY-MM-DD") : "";
        customFilter.end_date = moment(customFilter.end_date).isValid() ? moment(customFilter.end_date).format("YYYY-MM-DD") : "";
        customFilter.user_id = customFilter.user_id ? customFilter.user_id : "";

        if (customFilter.product_id && customFilter.product_id.length > 0) customFilter.product_id = customFilter.product_id.map((v) => v.product_id);

        axios({
            url: process.env.REACT_APP_WEBSITE_BACKEND_URL + "api/v1/services/export",
            method: "GET",
            responseType: "blob",
            params: {
                filter: JSON.stringify(customFilter),
            },
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
        });
    };

    const fetchData = useCallback(async () => {
        try {
            let customFilter = { ...filter };
            customFilter.start_date = moment(customFilter.start_date).isValid() ? moment(customFilter.start_date).format("YYYY-MM-DD") : "";
            customFilter.end_date = moment(customFilter.end_date).isValid() ? moment(customFilter.end_date).format("YYYY-MM-DD") : "";
            customFilter.user_id = customFilter.user_id ? customFilter.user_id : "";

            if (customFilter.product_id && customFilter.product_id.length > 0) customFilter.product_id = customFilter.product_id.map((v) => v.product_id);

            const { data } = await axios.get(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/services`, {
                params: {
                    page: page + 1,
                    perPage,
                    filter: JSON.stringify(customFilter),
                    sort,
                },
            });

            const pendingResponse = await axios.get(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/services/get-service-pending-count`);
            setPendingCount(pendingResponse ? pendingResponse.data.data.pendingCount.total : 0);
            setpendingCompleteCount(pendingResponse ? pendingResponse.data.data.pendingCompleteCount.total : 0);

            setData(data.data.services);
            setCount(data.data.total);
        } catch (error) {
            if (error.response.status === 401) {
                console.log("Unauthorized: ", error);
                logout("Your account has been logged out of a session.");
            } else {
                console.log(error);
            }
        }
    }, [page, perPage, filter, sort, logout]);

    useEffect(() => {
        fetchData();
    }, [fetchData, page, perPage, filter, sort]);

    useEffect(() => {
        setPage(0);
        setFilter(prevFilter => ({ ...prevFilter, start_date: startDate, end_date: endDate }));
    }, [startDate, endDate]);

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_WEBSITE_BACKEND_URL + "api/v1/users/select/access-country")
            .then((response) => {
                setUsersData(response.data.data.users);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/products/select?country=${filter.country_id}`)
            .then((response) => {
                setProductsData(response.data.data.products);
            })
            .catch((error) => console.log(error));
    }, [filter.country_id]);

    const handlePdfMenuOpen = (event, row) => {
        setPdfMenuAnchorEl(event.currentTarget);
        setSelectedPdfRow(row);
        setSelectedService(row);
    };

    const handlePdfMenuClose = () => {
        setPdfMenuAnchorEl(null);
    };

    const handleGeneratePdf = (skipConfirmation = false) => {
        if (!selectedService) return;

        const generatePdf = async () => {
            try {
                Swal.fire({
                    title: selectedService?.job_sheet_pdf ? 'Regenerating PDF...' : 'Generating PDF...',
                    html: 'Please wait...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const response = await axios.post(process.env.REACT_APP_WEBSITE_BACKEND_URL + 'api/v1/services/generate-pdf', {
                    serviceId: selectedService.service_id
                });

                if (response.status === 200) {
                    const updatedServiceResponse = await axios.get(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/services/${selectedService.service_id}`);
                    const updatedService = updatedServiceResponse.data.data;
                    
                    setPdfMenuAnchorEl(null);
                    setSelectedPdfRow(null);
                    setSelectedService(null);
                    fetchData();

                    if (updatedService.job_sheet_pdf) {
                        const result = await Swal.fire({
                            title: 'Success!',
                            text: 'PDF has been generated successfully. Would you like to view it now?',
                            icon: 'success',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, view PDF',
                            cancelButtonText: 'No, thanks'
                        });

                        if (result.isConfirmed) {
                            const pdfUrl = process.env.REACT_APP_WEBSITE_BACKEND_URL + updatedService.job_sheet_pdf.substring(1);
                            window.open(pdfUrl, '_blank');
                        }
                    } else {
                        await Swal.fire({
                            title: 'Success!',
                            text: 'PDF has been generated successfully.',
                            icon: 'success',
                            timer: 1500,
                            showConfirmButton: false
                        });
                    }
                }
            } catch (error) {
                console.error('Error generating PDF:', error);
                Swal.fire({
                    title: 'Error!',
                    text: error.response?.data?.message || 'Failed to generate PDF. Please try again.',
                    icon: 'error',
                });
                setPdfMenuAnchorEl(null);
                setSelectedPdfRow(null);
                setSelectedService(null);
            }
        };

        if (skipConfirmation) {
            generatePdf();
            return;
        }

        setPdfMenuAnchorEl(null); 
        Swal.fire({
            title: selectedService?.job_sheet_pdf ? 'Regenerate PDF' : 'Generate PDF',
            text: `Are you sure you want to ${selectedService?.job_sheet_pdf ? 'regenerate' : 'generate'} a PDF for service ${selectedService?.service_no}?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, ${selectedService?.job_sheet_pdf ? 'regenerate' : 'generate'} it!`,
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                generatePdf();
            }
            if (!result.isConfirmed) {
                setSelectedPdfRow(null);
                setSelectedService(null);
            }
        });
    };

    const handleViewPdf = () => {
        setPdfMenuAnchorEl(null);
        
        if (selectedService?.job_sheet_pdf) {
            const pdfUrl = process.env.REACT_APP_WEBSITE_BACKEND_URL + selectedService.job_sheet_pdf.substring(1);
            window.open(pdfUrl, '_blank');
            setSelectedPdfRow(null);
            setSelectedService(null);
        } else {
            Swal.fire({
                title: 'PDF Not Available',
                text: `Would you like to generate a PDF for service ${selectedService?.service_no}?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, generate it!',
                cancelButtonText: 'Cancel'
            }).then((result) => {
                if (result.isConfirmed) {
                    handleGeneratePdf(true);
                } else {
                    setSelectedPdfRow(null);
                    setSelectedService(null);
                }
            });
        }
    };

    const handleSendPdf = () => {
        setPdfMenuAnchorEl(null); 
        
        axios.get(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/email-templates/country/${selectedService.country_id}`)
            .then((response) => {
                if (response.status === 200) {
                    setEmailTemplate({
                        subject: response.data.data.subject,
                        body: response.data.data.body
                    });
                    setEmailDialogOpen(true);
                }
            })
            .catch((error) => {
                console.error('Error fetching email template:', error);
                if (error.response?.status === 404) {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Email template not found for this country. Please contact administrator.',
                        icon: 'error',
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Failed to fetch email template. Please try again.',
                        icon: 'error',
                    });
                }
            });
    };

    const handleEmailTemplateChange = (field, value) => {
        setEmailTemplate(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const validateEmailFormat = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email.trim());
    };

    const validateEmailList = (emailList) => {
        if (!emailList) return true;
        const emails = emailList.split(',').map(email => email.trim()).filter(email => email.length > 0);
        return emails.every(email => validateEmailFormat(email));
    };

    const handleSendEmail = () => {
        if (emailTemplate.cc && !validateEmailList(emailTemplate.cc)) {
            Swal.fire({
                title: 'Invalid Email Format',
                text: 'Please check the CC email addresses format',
                icon: 'error',
            });
            return;
        }

        if (emailTemplate.bcc && !validateEmailList(emailTemplate.bcc)) {
            Swal.fire({
                title: 'Invalid Email Format',
                text: 'Please check the BCC email addresses format',
                icon: 'error',
            });
            return;
        }

        Swal.fire({
            title: 'Sending PDF...',
            html: 'Please wait...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const ccArray = (emailTemplate.cc || '')
            .split(',')
            .map(email => email.trim())
            .filter(email => email.length > 0);

        const bccArray = (emailTemplate.bcc || '')
            .split(',')
            .map(email => email.trim())
            .filter(email => email.length > 0);

        axios.post(process.env.REACT_APP_WEBSITE_BACKEND_URL + 'api/v1/services/send-pdf', {
            serviceId: selectedService.service_id,
            emailSubject: emailTemplate.subject,
            emailBody: emailTemplate.body,
            emailCc: ccArray,
            emailBcc: bccArray
        })
        .then((response) => {
            if (response.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: 'PDF has been sent successfully.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        })
        .catch((error) => {
            console.error('Error sending PDF:', error);
            Swal.fire({
                title: 'Error!',
                text: error.response?.data?.message || 'Failed to send PDF. Please try again.',
                icon: 'error',
            });
        })
        .finally(() => {
            setEmailDialogOpen(false);
            setSelectedPdfRow(null);
            setSelectedService(null);
        });
    };

    const columns = [
        {
            title: "Service Date",
            field: "service_date",
            cellStyle: { width: 130, maxWidth: 130 },
            headerStyle: { width: 130, maxWidth: 130 },
            render: (rowData) => moment(rowData.service_date).format("YYYY-MM-DD"),
        },
        {
            title: "Service No",
            field: "service_no",
            cellStyle: { width: 120, maxWidth: 120 },
            headerStyle: { width: 120, maxWidth: 120 }
        },
        {
            title: "Organization",
            field: "org_name",
            cellStyle: { width: 720, maxWidth: 720 },
            headerStyle: { width: 720, maxWidth: 720 },
            render: (rowData) => 
            <>
                {rowData.org_id === 1 || rowData.org_id === 2 ? `${rowData.org_name} (${rowData.ref_org})` : rowData.org_name}
                <br/>
                {rowData.details && rowData.details.map(detail => (
                    <Chip key={detail.product_id} label={detail.product_description} size="small" variant="outlined" sx={{ mx: 0.3, my: 0.1 }}/>
                ))}
            </>
        },
        {   title: "Support By", field: "support_name", width: "80%" },
        {   
            title: "Status", field: "status", 
            align: "center",
            cellStyle: { width: 55, maxWidth: 55 }, headerStyle: { width: 55, maxWidth: 55 },
            render: (rowData) => 
            <>
                { rowData.status === 0 ?
                    <Tooltip title={rowData.is_request_close === 1 ? "Pending & Requested Complete" : "Pending"}>
                        <IconButton color="primary" aria-label="completed" component="label" style={{ padding: 0, marginRight: 2 }} >
                            { rowData.is_request_close === 1 ? <Icons.PendingTwoToneIcon/> : <Icons.AccessTimeTwoToneIcon />}
                        </IconButton>
                    </Tooltip> 
                    :
                    <Tooltip title="Completed">
                        <IconButton color="primary" aria-label="completed" component="label" style={{ padding: 0, marginRight: 2 }} >
                            <Icons.VerifiedTwoToneIcon />
                        </IconButton>
                    </Tooltip> 
                }
            </>
        },
        {   
            title: "Views", field: "status", 
            align: "center",
            cellStyle: { width: 55, maxWidth: 55 }, headerStyle: { width: 55, maxWidth: 55 },
            render: (rowData) => 
            <>
                {rowData.contract_id > 0 && 
                    <Tooltip title="View Contract">
                        <IconButton color="primary" aria-label="view contract detail" component="label" style={{ padding: 0 }} onClick={() => handleOpen("viewContract", rowData)}>
                            <Icons.Summarize />
                        </IconButton>
                    </Tooltip> 
                }
            </>
        },
        {   
            title: "Re.", field: "status", 
            align: "center",
            cellStyle: { width: 55, maxWidth: 55 }, headerStyle: { width: 55, maxWidth: 55 },
            render: (rowData) => 
            <>
                <Tooltip title={rowData.status === 0 ? "Create Continue Service" : "View Continue Service"}>
                    <IconButton color="primary" aria-label="create continur service" component="label" style={{ padding: 0, marginRight: 8 }} onClick={() => handleOpen("viewService", rowData)}>
                        <Icons.PhoneForwardedTwoToneIcon />
                    </IconButton>
                </Tooltip> 
            </>
        },
        {   
            title: "Actions", field: "status", 
            align: "center",
            cellStyle: { width: 150, maxWidth: 150 }, headerStyle: { width: 150, maxWidth: 150 },
            render: (rowData) => 
            <>
                {((rowData.status === 0 && rowData.support_by !== identity.user.user_id) || (rowData.status === 1)) && 
                    <Tooltip title="View Service Information">
                        <IconButton color="primary" aria-label="view service information" component="label" style={{ padding: 0 }} onClick={() => handleOpen("view", rowData)}>
                            <Icons.Preview />
                        </IconButton>
                    </Tooltip> 
                }
                {((rowData.status === 0 && rowData.support_by === identity.user.user_id) || identity.user.role_id === 1) && 
                    <Tooltip title="Edit Service Information">
                        <IconButton color="primary" aria-label="edit service information" component="label" style={{ padding: 0, marginLeft: 8 }} onClick={() => handleOpen("edit", rowData)}>
                            <Icons.Edit />
                        </IconButton>
                    </Tooltip> 
                }
                {((rowData.support_by === identity.user.user_id) || identity.user.role_id === 1) && 
                <Tooltip title="Job Sheet PDF">
                    <IconButton 
                        color="primary" 
                        aria-label="job sheet pdf" 
                        component="label" 
                        style={{ padding: 0, marginLeft: 8 }} 
                        onClick={(event) => handlePdfMenuOpen(event, rowData)}
                    >
                        <Icons.PictureAsPdf />
                    </IconButton>
                </Tooltip>
                }
                {rowData.status === 0 && rowData.support_by === identity.user.user_id && 
                    <Tooltip title="Delete Service">
                        <IconButton color="primary" aria-label="delete service" component="label" style={{ padding: 0, marginLeft: 8 }} onClick={() => DeleteServiceForm(rowData, fetchData)}>
                            <Icons.Delete />
                        </IconButton>
                    </Tooltip> 
                }
            </>
        },
    ];

    const actions = [];

    // actions.push({
    //     icon: () => <Icons.Edit />,
    //     tooltip: "Edit Service Information",
    //     onClick: (event, rowData) => handleOpen("edit", rowData),
    // });
    // actions.push({
    //     icon: () => <Icons.Delete />,
    //     tooltip: "Delete Service",
    //     onClick: (event, rowData) => DeleteServiceForm(rowData, fetchData),
    // });

    return (
        <div>
            <div className={classes.background} />
            <Container maxWidth="xl" sx={{ py: 2 }} style={{ padding: 14 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Card sx={{ minWidth: 275, mb: 2 }}>
                            <CardContent sx={{ pt: 1, pb: 0 }}>
                                <Typography variant="h6" component="div">
                                    Your Pending Service 
                                </Typography>
                                <Typography variant="h5" component="div" sx={{ mt: 1 }}>
                                    {pendingCount}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" onClick={() => handlePendingFilter()}>Filter Pending Service</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Card sx={{ minWidth: 275, mb: 2 }}>
                            <CardContent sx={{ pt: 1, pb: 0 }}>
                                <Typography variant="h6" component="div">
                                    Your Pending Complete Service 
                                </Typography>
                                <Typography variant="h5" component="div" sx={{ mt: 1 }}>
                                    {pendingCompleteCount}
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button size="small" onClick={() => handlePendingCompleteFilter()}>Filter Pending Complete Service</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
                <MaterialTable
                    title="Services List"
                    icons={Icons}
                    columns={columns}
                    data={data}
                    page={page}
                    totalCount={count}
                    style={{ padding: "24px" }}
                    options={{
                        pageSize: perPage,
                        pageSizeOptions: [10, 20, 30, 50],
                        search: false,
                        filtering: false,
                        sorting: false,
                        actionsColumnIndex: -1,
                        headerStyle: {
                            fontWeight: "bold",
                            backgroundColor: "#f1f1f1",
                            color: "#212122",
                        },
                        maxBodyHeight: "600px",
                        paginationType: "stepped",
                        padding: "dense",
                        draggable: false
                    }}
                    localization={{
                        pagination: {
                            labelRowsPerPage: "",
                            labelDisplayedRows: "{from}-{to} of {count}",
                            labelRowsSelect: "rows",
                        },
                        toolbar: {
                            nRowsSelected: "{0} row(s) selected",
                        },
                        header: {
                            actions: "Actions",
                        },
                        body: {
                            emptyDataSourceMessage: "No data to display",
                            filterRow: {
                                filterTooltip: "Filter",
                            },
                        },
                    }}
                    actions={actions}
                    onChangePage={(page) => setPage(page)}
                    onChangeRowsPerPage={(perPage) => setPerPage(perPage)}
                    components={{
                        Toolbar: (props) => (
                            <>
                                <div>
                                    <Grid container spacing={2} sx={{ px: 0.1, pb: 3.5 }}>
                                        <Grid item xs={12} sm={3}>
                                            <CardHeader
                                                sx={{ p: 0 }}
                                                title={
                                                    <Typography component="h1" variant="h5" color="primary" fontWeight="bold">
                                                        Services List
                                                    </Typography>
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={9} style={{ textAlign: "right" }}>
                                            <ButtonGroup>
                                                <Button
                                                    onClick={() => handleOpen("create", null)}
                                                    variant="outlined"
                                                    startIcon={<Icons.AddIcon fontWeight="bold" />}
                                                    color="primary"
                                                    sx={{
                                                        fontWeight: 800,
                                                        paddingTop: 0.5,
                                                        paddingBottom: 0.5,
                                                    }}
                                                >
                                                    Create
                                                </Button>
                                                {identity.user.role_id === 1 && (
                                                    <>
                                                        <Button
                                                            onClick={() => handleOpen("import", null)}
                                                            variant="outlined"
                                                            startIcon={<Icons.Import fontWeight="bold" />}
                                                            color="primary"
                                                            sx={{
                                                                fontWeight: 800,
                                                                paddingTop: 0.5,
                                                                paddingBottom: 0.5,
                                                            }}
                                                        >
                                                            Import
                                                        </Button>
                                                        <Button
                                                            onClick={() => downloadExcelFile()}
                                                            variant="outlined"
                                                            startIcon={<Icons.FileDownload fontWeight="bold" />}
                                                            color="primary"
                                                            sx={{
                                                                fontWeight: 800,
                                                                paddingTop: 0.5,
                                                                paddingBottom: 0.5,
                                                            }}
                                                        >
                                                            Export
                                                        </Button>
                                                    </>
                                                )}
                                            </ButtonGroup>
                                        </Grid>
                                    </Grid>
                                </div>

                                <form>
                                    <Grid container spacing={2} sx={{ paddingBottom: 1.5 }}>
                                        <Grid item xs={12} sm={2} md={1.2} xl={1.2}>
                                            <TextField
                                                autoComplete="off"
                                                fullWidth
                                                label="Service No"
                                                name="service_no"
                                                variant="outlined"
                                                autoFocus={serviceNoInputRef.current === document.activeElement}
                                                value={filter.service_no}
                                                onChange={handleFilterChange}
                                                inputRef={serviceNoInputRef}
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    style: { textTransform: "uppercase" },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={2} md={1.3} xl={1.3}>
                                            <TextField
                                                label="Service Date (Start)"
                                                fullWidth
                                                type="text"
                                                size="small"
                                                value={startDate ? formatDate(startDate) : ""}
                                                // onChange={(event) => setStartDate(event.target.value)}
                                                onClick={() => setIsDialogOpen(true)}
                                                InputProps={{ readOnly: true }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <Dialog open={isDialogOpen} onClose={handleDialogClose}>
                                                <DateRangePicker onClose={handleDialogClose} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
                                            </Dialog>
                                        </Grid>
                                        <Grid item xs={6} sm={2} md={1.3} xl={1.3}>
                                            <TextField
                                                label="Service Date (End)"
                                                fullWidth
                                                type="text"
                                                size="small"
                                                value={endDate ? formatDate(endDate) : ""}
                                                // onChange={(event) => setEndDate(event.target.value)}
                                                onClick={() => setIsDialogOpen(true)}
                                                InputProps={{ readOnly: true }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={2.0} xl={2.0}>
                                            <TextField
                                                autoComplete="off"
                                                fullWidth
                                                label="Organization"
                                                name="org_name"
                                                variant="outlined"
                                                autoFocus={organizationInputRef.current === document.activeElement}
                                                value={filter.org_name}
                                                onChange={handleFilterChange}
                                                inputRef={organizationInputRef}
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    style: { textTransform: "uppercase" },
                                                }}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={12} sm={4} md={2.5} xl={2.5}>
                                            <TextField
                                                autoComplete="off"
                                                fullWidth
                                                label="Product"
                                                name="product_description"
                                                variant="outlined"
                                                autoFocus={ProductInputRef.current === document.activeElement}
                                                value={filter.product_description}
                                                onChange={handleFilterChange}
                                                inputRef={ProductInputRef}
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>*/}
                                        {(<Grid item xs={12} sm={4} md={1.9} xl={1.9} style={{ marginTop: "-8px"}}>
                                            <Autocomplete
                                                freeSolo
                                                size="small"
                                                name="user_id"
                                                options={usersData}
                                                groupBy={(option) => {
                                                    const country = Countries.find((country) => country.id === option.country_id);
                                                    return country ? country.name : "Unknown";
                                                }}
                                                value={usersData.filter((user) => user.user_id === filter.user_id)[0] || ""}
                                                getOptionLabel={(option) => option.name || ""}
                                                onChange={(_, selectedValue) => handleUserFilterChange(selectedValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        margin="dense"
                                                        id="user_id"
                                                        label="Support By"
                                                        fullWidth
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                )}
                                                renderGroup={(params) => {
                                                    return (
                                                        <li key={params.key}>
                                                            <GroupHeader>{params.group}</GroupHeader>
                                                            <GroupItems>{params.children}</GroupItems>
                                                        </li>
                                                    );
                                                }}
                                            />
                                        </Grid>)}
                                        <Grid item xs={6} sm={3} md={1.4} xl={1.4}>
                                            <TextField
                                                fullWidth
                                                select
                                                label="Status"
                                                variant="outlined"
                                                name="status"
                                                value={filter.status}
                                                onChange={handleFilterChange}
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            >
                                                <MenuItem value={""}>All</MenuItem>
                                                {ServiceStatus.map((status) => (
                                                    <MenuItem key={status.id} value={status.id}>
                                                        {status.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>        
                                        <Grid item xs={6} sm={3} md={1.4} xl={1.4}>
                                            <TextField
                                                fullWidth
                                                select
                                                label="Is Request Complete"
                                                variant="outlined"
                                                name="is_request_close"
                                                value={filter.is_request_close}
                                                onChange={handleFilterChange}
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            >
                                                <MenuItem value={""}>All</MenuItem>
                                                <MenuItem value={0}>No</MenuItem>
                                                <MenuItem value={1}>Yes</MenuItem>
                                            </TextField>
                                        </Grid>                  
                                        <Grid item xs={6} sm={3.8} md={1.5} xl={1.5}>
                                            <CountrySelect 
                                                value={filter.country_id === undefined ? "" : filter.country_id} 
                                                onChange={handleFilterChange} 
                                            />
                                        </Grid>                             
                                        <Grid item xs={12} sm={10} md={11} style={{ paddingTop: 8.5 }}>
                                            <Autocomplete
                                                multiple
                                                size="small"
                                                name="product_id"
                                                options={productsData}
                                                groupBy={(option) => {
                                                    const country = Countries.find((country) => country.id === option.country_id);
                                                    return country ? country.name : "Unknown";
                                                }}
                                                value={filter.product_id}
                                                getOptionLabel={(option) => option.product_description}
                                                onChange={(_, selectedValue) => handleProductFilterChange(selectedValue)}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox icon={Icons.CheckBoxBlankIcon} checkedIcon={Icons.CheckBoxCheckedIcon} style={{ marginRight: 8 }} checked={selected} />
                                                        {option.product_description}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        margin="dense"
                                                        id="product_id"
                                                        label="Product"
                                                        fullWidth
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                )}
                                                renderGroup={(params) => {
                                                    return (
                                                        <li key={params.key}>
                                                            <GroupHeader>{params.group}</GroupHeader>
                                                            <GroupItems>{params.children}</GroupItems>
                                                        </li>
                                                    );
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={1}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                color="error"
                                                sx={{
                                                    color: "#ffffff",
                                                    marginTop: "2px",
                                                }}
                                                onClick={handleResetFilter}
                                            >
                                                Reset
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </>
                        ),
                    }}
                />
                <Menu
                    anchorEl={pdfMenuAnchorEl}
                    open={Boolean(pdfMenuAnchorEl)}
                    onClose={handlePdfMenuClose}
                >
                    <MenuItem onClick={() => handleGeneratePdf(false)}>
                        {selectedService?.job_sheet_pdf ? 'Regenerate PDF' : 'Generate PDF'}
                    </MenuItem>
                    <MenuItem 
                        onClick={handleViewPdf}
                        disabled={!selectedService?.job_sheet_pdf}
                        sx={{ 
                            color: !selectedService?.job_sheet_pdf ? 'text.disabled' : 'inherit'
                        }}
                    >
                        View PDF
                    </MenuItem>
                    <MenuItem 
                        onClick={handleSendPdf}
                        disabled={!selectedService?.job_sheet_pdf}
                        sx={{ 
                            color: !selectedService?.job_sheet_pdf ? 'text.disabled' : 'inherit'
                        }}
                    >
                        Send PDF
                    </MenuItem>
                </Menu>
                <CreateServiceForm open={open.create} handleClose={() => handleClose("create")} fetchData={fetchData} />
                <EditServiceForm open={open.edit} handleClose={() => handleClose("edit")} rowData={selectedRow} fetchData={fetchData} />
                <ViewServiceForm open={open.view} handleClose={() => handleClose("view")} rowData={selectedRow} />
                <ImportServiceForm open={open.import} handleClose={() => handleClose("import")} fetchData={fetchData} userCountry={userCountry} />
                <ViewContractForm open={open.viewContract} handleClose={() => handleClose("viewContract")} rowData={selectedRow} />
                <RelationshipServicesForm open={open.viewService} handleClose={() => handleClose("viewService")} rowData={selectedRow} />
                <Dialog 
                    open={emailDialogOpen} 
                    onClose={() => setEmailDialogOpen(false)}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>Send Service PDF Email</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Email Subject"
                            type="text"
                            fullWidth
                            value={emailTemplate.subject}
                            onChange={(e) => handleEmailTemplateChange('subject', e.target.value)}
                            error={!emailTemplate.subject}
                            helperText={!emailTemplate.subject ? 'Subject is required' : ''}
                        />
                        <TextField
                            margin="dense"
                            label="Email Body"
                            type="text"
                            fullWidth
                            multiline
                            rows={10}
                            value={emailTemplate.body}
                            onChange={(e) => handleEmailTemplateChange('body', e.target.value)}
                            error={!emailTemplate.body}
                            helperText={!emailTemplate.body ? 'Body is required' : ''}
                            style={{ marginBottom: "10px" }}
                        />
                        <TextField
                            margin="dense"
                            label="Email CC"
                            type="text"
                            fullWidth
                            value={emailTemplate.cc}
                            onChange={(e) => handleEmailTemplateChange('cc', e.target.value)}
                            helperText="Optional: Example: john@example.com,jane@example.com"
                            placeholder="john@example.com,jane@example.com"
                        />
                        <TextField
                            margin="dense"
                            label="Email BCC"
                            type="text"
                            fullWidth
                            value={emailTemplate.bcc}
                            onChange={(e) => handleEmailTemplateChange('bcc', e.target.value)}
                            helperText="Optional: Example: manager@example.com,supervisor@example.com"
                            placeholder="manager@example.com,supervisor@example.com"
                        />
                    </DialogContent>
                    <DialogActions style={{ margin: "12px" }}>
                        <Button 
                            onClick={handleSendEmail} 
                            variant="contained" 
                            color="primary"
                            disabled={!emailTemplate.subject || !emailTemplate.body}
                            style={{ marginRight: "6px", color: "white" }}
                        >
                            Send
                        </Button>
                        <Button 
                            onClick={() => setEmailDialogOpen(false)} 
                            variant="contained" 
                            color="error"
                            style={{ marginRight: "6px", color: "white" }}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </div>
    );
};
